<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import TmpApi from '@/services/api/tmp.api'
import codeApi from '@/services/api/code.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () =>
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Anejo 7 - Cantidad de Años en SR',
      routes: ["Informes", "Anejo 7 - Cantidad de Años en SR"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          regions: [],
          centers: [],
          municipalities: [],
          schools: [],
          providers: [],
          specialists: [],
          serviceTypes: [],

        },
        filters: {
          academicYear: null,
          region: null,
          center: null,
          municipality: null,
          school: null,
          specialist: null,
          provider: null,
          serviceType: null,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        clearable: false,
        class: 'col-md-3',
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onChangeAcademicYear,
      },
      {
        name: 'region',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Región',
        placeholder: 'Seleccionar',
        clearable: true,
        class: 'col-md-3',
        options: this.model.search.collections.regions,
        value: this.model.search.filters.region,
        onChanged: this.onChangeRegion,
        disabled: this.model.search.collections.regions.length <= 0
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Centro',
        placeholder: 'Seleccionar',
        clearable: true,
        class: 'col-md-3',
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        onChanged: this.onChangeCenter,
        disabled: this.model.search.collections.centers.length <= 0
      },
      {
        name: 'municipality',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Municipio',
        placeholder: 'Seleccionar',
        clearable: true,
        class: 'col-md-3',
        options: this.model.search.collections.municipalities,
        value: this.model.search.filters.municipality,
        onChanged: this.onChangeMunicipality,
        disabled: this.model.search.collections.municipalities.length <= 0
      },
      {
        name: 'school',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Escuela',
        placeholder: 'Seleccionar',
        clearable: true,
        class: 'col-md-3',
        options: this.model.search.collections.schools,
        value: this.model.search.filters.school,
        onChanged: this.onChangeSchool,
        disabled: this.model.search.collections.schools.length <= 0
      },
      {
        name: 'provider',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        placeholder: 'Seleccionar',
        clearable: true,
        class: 'col-md-3',
        options: this.model.search.collections.providers,
        value: this.model.search.filters.provider,
        onChanged: this.onChangeProvider,
        disabled: this.model.search.collections.providers.length <= 1
      },
      {
        name: 'specialist',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Especialista',
        placeholder: 'Seleccionar',
        clearable: true,
        class: 'col-md-3',
        options: this.model.search.collections.specialists,
        value: this.model.search.filters.specialist,
        disabled: this.model.search.collections.specialists.length <= 1
      },
      {
          name: 'sie',
          component: 'CustomInput',
          placeholder: 'Escriba Número de SIE',
          label: 'SIE',
          icon: 'fa fa-search orange-icon',
          value: this.model.search.filters.sie,
          leftIcon: true,
          type: 'number',
          class: 'col-md-3'
        },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);

       await codeApi.GetTransitionalServicesFilters()
        .then(res => this.model.search.collections.serviceTypes = res.data);
    },

    async onHandlerSearch() {
      this.process();
    },
    async process() {
      await ReportServices.getReport('anejo7', {
         academicYearId: this.model.search.filters.academicYear.id,
         regionId: this.model.search.filters.region?.id,
         serviceCenterId: this.model.search.filters.center?.id,
         municipalityId: this.model.search.filters.municipality?.id,
         schoolId: this.model.search.filters.school?.id,
         companyId: this.model.search.filters.provider?.id,
         specialistId: this.model.search.filters.specialist?.id,
         disciplineTypeId: this.model.search.filters.serviceType?.id,
         studentSieId: this.model.search.filters.sie,
      })
      .then(res => DocumentServices.Download(res.data));
    },
     async onChangeAcademicYear() {
      this.model.search.filters.region = null;
      this.model.search.collections.regions = [];
      this.model.search.filters.center = null;
      this.model.search.collections.centers = [];
      this.model.search.filters.municipality = null;
      this.model.search.collections.municipalities = [];
      this.model.search.filters.school = null;
      this.model.search.collections.schools = [];
      this.model.search.filters.provider = null;
      this.model.search.collections.providers = [];
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      await this.getRegion();
    },
    async onChangeRegion() {
      this.model.search.filters.center = null;
      this.model.search.collections.centers = [];
      this.model.search.filters.municipality = null;
      this.model.search.collections.municipalities = [];
      this.model.search.filters.school = null;
      this.model.search.collections.schools = [];
      this.model.search.filters.provider = null;
      this.model.search.collections.providers = [];
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      if(this.model.search.filters.region !== null)
        await this.getCenter();
    },
    async onChangeCenter() {
      this.model.search.filters.municipality = null;
      this.model.search.collections.municipalities = [];
      this.model.search.filters.school = null;
      this.model.search.collections.schools = [];
      this.model.search.filters.provider = null;
      this.model.search.collections.providers = [];
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      if(this.model.search.filters.center !== null)
        await this.getMunicipality();
    },
    async onChangeMunicipality() {
      this.model.search.filters.school = null;
      this.model.search.collections.schools = [];
      this.model.search.filters.provider = null;
      this.model.search.collections.providers = [];
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      if(this.model.search.filters.municipality !== null)
        await this.getSchool();
    },
    async onChangeSchool() {
      this.model.search.filters.provider = null;
      this.model.search.collections.providers = [];
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];


      if(this.model.search.filters.school !== null)
        await this.getProvider();
    },
    async onChangeProvider() {
      this.model.search.filters.specialist = null;
      this.model.search.collections.specialists = [];

      if(this.model.search.filters.provider !== null)
        await this.getSpecialist();
    },
    async getRegion(){
      await TmpApi.getRegionByAcademicYear({anejoNum: 16, academicYearId: this.model.search.filters.academicYear?.id})
      .then(res => {
        this.model.search.collections.regions = res.data;

      });
    },
    async getCenter(){
      await TmpApi.getCenters({
        anejoNum: 7,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id})
      .then(res => {
        this.model.search.collections.centers = res.data;

      });
    },
     async getMunicipality(){
      await TmpApi.getMunicipality({
        anejoNum: 7,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,})
      .then(res => {
        this.model.search.collections.municipalities = res.data;
      });
    },
    async getSchool(){
      await TmpApi.getSchool({
        anejoNum: 7,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        municipalityId: this.model.search.filters.municipality?.id,})
      .then(res => {
        this.model.search.collections.schools = res.data;
      });
    },
    async getProvider(){
      const res = await TmpApi.getProvider({
        anejoNum: 7,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        locationSchoolId: this.model.search.filters.school?.id,});
      
      this.model.search.collections.providers = res.data;
      
      if (res.data.length == 1) {
        this.model.search.filters.provider = res.data[0];
        await this.getSpecialist();
      } else if (res.data.length > 0) {
        const providerSelected = res.data?.find((x) => x?.selected);
        if (providerSelected) {
          this.model.search.filters.provider = providerSelected;
          await this.getSpecialist();
        }
      }
    },
    async getSpecialist(){
      await TmpApi.getSpecialist({
        anejoNum: 7,
        academicYearId: this.model.search.filters.academicYear?.id,
        regionId: this.model.search.filters.region?.id,
        centerId: this.model.search.filters.center?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        locationSchoolId: this.model.search.filters.school?.id,
        companyId: this.model.search.filters.provider?.id,})
      .then(res => {
        this.model.search.collections.specialists = res.data;

        if (res.data.length == 1) {
          this.model.search.filters.specialist = res.data[0];
        }
      });
    },
  },
}
</script>
